import { gql } from "graphql-tag";

export const GET_PRICING_ALL = gql`
  query pricingAll {
    pricingAll {
      id
      pricingTypeId
      thresholdTypeId
      minimumPrice
      unitThreshold
      annualDiscountPercent
      monthlyPricePerUnit
      insertedAt
      updatedAt
      tiers {
        id
        lowerThreshold
        monthlyPrice
      }
      pricingType {
        id
        name
      }
      thresholdType {
        id
        name
      }
    }
  }
`;

export const GET_PRICING_BY_ID = gql`
  query pricing($id: ID!) {
    pricing(id: $id) {
      id
      pricingTypeId
      thresholdTypeId
      minimumPrice
      unitThreshold
      annualDiscountPercent
      monthlyPricePerUnit
      insertedAt
      updatedAt
      tiers {
        id
        lowerThreshold
        monthlyPrice
      }
      pricingType {
        id
        name
      }
      thresholdType {
        id
        name
      }
    }
  }
`;

export const CREATE_PRICING = gql`
  mutation createPricing($data: PricingInput!) {
    createPricing(data: $data) {
      id
      pricingTypeId
      thresholdTypeId
      minimumPrice
      unitThreshold
      annualDiscountPercent
      monthlyPricePerUnit
      insertedAt
      updatedAt
      tiers {
        id
        lowerThreshold
        monthlyPrice
      }
      pricingType {
        id
        name
      }
      thresholdType {
        id
        name
      }
    }
  }
`;

export const UPDATE_PRICING = gql`
  mutation updatePricing($id: ID!, $data: PricingUpdateInput!) {
    updatePricing(id: $id, data: $data) {
      id
      pricingTypeId
      thresholdTypeId
      minimumPrice
      unitThreshold
      annualDiscountPercent
      monthlyPricePerUnit
      insertedAt
      updatedAt
      tiers {
        id
        lowerThreshold
        monthlyPrice
      }
      pricingType {
        id
        name
      }
      thresholdType {
        id
        name
      }
    }
  }
`;

export const DELETE_PRICING = gql`
  mutation deletePricing($id: ID!) {
    deletePricing(id: $id) {
      id
    }
  }
`;

export const GET_PRICING_TYPES = gql`
  query pricingTypes {
    pricingTypes {
      id
      name
    }
  }
`;

export const GET_THRESHOLD_TYPES = gql`
  query thresholdTypes {
    thresholdTypes {
      id
      name
    }
  }
`;

export const PRICING_CALCULATOR = gql`
  query pricingCalculator($unitCount: Int!, $pricing: PricingCalculatorInput!) {
    pricingCalculator(unitCount: $unitCount, pricing: $pricing) {
      grandTotal
      averagePerUnit
      minimumApplied
      thresholdMet
      minimumIgnored
      lines {
        rate
        unitCount
        subtotal
      }
    }
  }
`;
